import { requireAccess } from './permission'

export const health = [
  {
    path: '/saude/noticias/:type?/:page?/:id?',
    name: 'HealthArticles',
    component: () => import('views/verticals/health/articles/Main'),
    title: 'Artigos',
    icon: 'fa-file-o',
    type: 'vertical',
    menu: true,
    subitems: [
      {
        title: 'Listar',
        type: 'listar',
        submenu: true
      },
      {
        title: 'Cadastrar',
        type: 'cadastrar',
        submenu: true
      },
      {
        title: 'Editar',
        type: 'editar',
        submenu: false
      }
    ],
    adminAccess: true,
    beforeEnter: requireAccess,
    meta: {
      permission: 'admin-health'
    }
  },
  // {
  //   path: '/saude/temas/:type?/:page?/:id?',
  //   name: 'HealthThemes',
  //   component: () => import('views/verticals/health/themes/Main'),
  //   title: 'Temas',
  //   icon: 'fa-tags',
  //   type: 'vertical',
  //   menu: true,
  //   subitems: [
  //     {
  //       title: 'Listar',
  //       type: 'listar',
  //       submenu: true
  //     },
  //     {
  //       title: 'Cadastrar',
  //       type: 'cadastrar',
  //       submenu: true
  //     },
  //     {
  //       title: 'Editar',
  //       type: 'editar',
  //       submenu: false
  //     }
  //   ]
  // },
  // {
  //   path: '/saude/autores/:type?/:page?/:id?',
  //   name: 'HealthAuthors',
  //   component: () => import('views/verticals/health/authors/Main'),
  //   title: 'Autores',
  //   icon: 'fa-pencil',
  //   type: 'vertical',
  //   menu: true,
  //   subitems: [
  //     {
  //       title: 'Listar',
  //       type: 'listar',
  //       submenu: true
  //     },
  //     {
  //       title: 'Cadastrar',
  //       type: 'cadastrar',
  //       submenu: true
  //     },
  //     {
  //       title: 'Editar',
  //       type: 'editar',
  //       submenu: false
  //     }
  //   ]
  // },
  // {
  //   path: '/saude/versions/:type?/:page?/:id?',
  //   name: 'Versions',
  //   component: () => import('views/verticals/health/versions'),
  //   title: 'Versão dos aplicativos',
  //   icon: 'fa-tablet',
  //   type: 'vertical',
  //   menu: true,
  //   subitems: [
  //     {
  //       title: 'Listar',
  //       type: 'listar',
  //       submenu: true
  //     },
  //     // {
  //     //   title: 'Cadastrar',
  //     //   type: 'cadastrar',
  //     //   submenu: true
  //     // },
  //     {
  //       title: 'Editar',
  //       type: 'editar',
  //       submenu: false
  //     }
  //   ],
  //   editorAccess: true,
  //   beforeEnter: requireAccess,
  //   meta: {
  //     permission: 'admin-health'
  //   }
  // },
  {
    path: '/saude',
    component: () => import('views/verticals/health/articles/Main')
  }
]



// WEBPACK FOOTER //
// ./src/router/health.js